import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './en.json';
import nl from './nl.json';
import fr from './fr.json';

// Static pages
import rulesEn from './static/rules/rules_en.json';
import rulesNl from './static/rules/rules_nl.json';
import rulesFr from './static/rules/rules_fr.json';
import termsEn from './static/terms/terms_en.json';
import termsNl from './static/terms/terms_nl.json';
import termsFr from './static/terms/terms_fr.json';
import privacyEn from './static/privacy/privacy_en.json';
import privacyNl from './static/privacy/privacy_nl.json';
import privacyFr from './static/privacy/privacy_fr.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'nl', 'fr'],
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: { translation: en, rules: rulesEn, privacy: privacyEn, terms: termsEn },
      nl: { translation: nl, rules: rulesNl, privacy: privacyNl, terms: termsNl },
      fr: { translation: fr, rules: rulesFr, privacy: privacyFr, terms: termsFr },
    },
    react: {
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['b', 'strong', 'u', 'br', 'sup', 'a'],
    },
  });
